import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import { API_URL, BASE_URL, normalizeList } from '../config';
import './SellersInAreaPage.css';

const SellersInAreaPage = () => {
  const [pinCode, setPinCode] = useState('');
  const [city, setCity] = useState('');
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState('');
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);
  useEffect(() => {
    axios.get(`${API_URL}/Categories`).then((res) => {
      setCategories(normalizeList(res.data));
    }).catch(() => setCategories([]));
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    setLoading(true);
    setSearched(true);
    const params = {};
    if (pinCode.trim()) params.pinCode = pinCode.trim();
    if (city.trim()) params.city = city.trim();
    if (categoryId) params.categoryId = categoryId;

    axios.get(`${API_URL}/SellersList`, { params })
      .then((res) => setSellers(normalizeList(res.data)))
      .catch(() => setSellers([]))
      .finally(() => setLoading(false));
  };

  const handleClearFilters = () => {
    setPinCode('');
    setCity('');
    setCategoryId('');
    setSellers([]);
    setSearched(false);
  };

  return (
    <div className="sellers-in-area-wrapper">
      <Header />
      <main className="sellers-in-area-main">
        <h1 className="sellers-in-area-heading">Find Sellers in Your Area</h1>
        <p className="sellers-in-area-subheading">
          Filter by pin code, city, or product category to discover sellers near you.
        </p>

        <form onSubmit={handleSearch} className="sellers-in-area-filters">
          <div className="sellers-in-area-filter-row">
            <label className="sellers-in-area-label">
              Pin code
              <input
                type="text"
                className="sellers-in-area-input"
                placeholder="e.g. 110001"
                value={pinCode}
                onChange={(e) => setPinCode(e.target.value)}
              />
            </label>
            <label className="sellers-in-area-label">
              City
              <input
                type="text"
                className="sellers-in-area-input"
                placeholder="e.g. Delhi"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </label>
          </div>

          <div className="sellers-in-area-filter-row">
            <label className="sellers-in-area-label">
              Primary category
              <select
                className="sellers-in-area-select"
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
              >
                <option value="">All</option>
                {categories.map((c) => (
                  <option key={c.categoryId} value={c.categoryId}>{c.categoryName}</option>
                ))}
              </select>
            </label>
          </div>

          <div className="sellers-in-area-actions">
            <button type="submit" className="sellers-in-area-btn sellers-in-area-btn-primary" disabled={loading}>
              {loading ? 'Searching…' : 'Search Sellers'}
            </button>
            <button type="button" className="sellers-in-area-btn sellers-in-area-btn-secondary" onClick={handleClearFilters}>
              Clear
            </button>
          </div>
        </form>

        {searched && (
          <section className="sellers-in-area-results">
            {loading ? (
              <p className="sellers-in-area-loading">Loading sellers…</p>
            ) : sellers.length === 0 ? (
              <p className="sellers-in-area-empty">No sellers found for your filters. Try different pin code, city, or category.</p>
            ) : (
              <>
                <p className="sellers-in-area-count">{sellers.length} seller{sellers.length !== 1 ? 's' : ''} found</p>
                <div className="sellers-in-area-table-wrap">
                  <table className="sellers-in-area-table">
                    <thead>
                      <tr>
                        <th>Seller ID</th>
                        <th>Name</th>
                        <th>Contact</th>
                        <th>Address</th>
                        <th>Location</th>
                        <th>Shop Photo</th>
                        <th>Primary Category</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sellers.map((seller) => (
                        <tr key={seller.sellerId}>
                          <td className="col-seller-id">{seller.sellerIdDisplay ?? seller.sellerId}</td>
                          <td>{seller.shopName || seller.name || '—'}</td>
                          <td>{seller.contact || '—'}</td>
                          <td>{seller.address || '—'}</td>
                          <td className="col-map-url">
                            {seller.shopMapUrl ? (
                              <a
                                href={/^https?:\/\//i.test(seller.shopMapUrl) ? seller.shopMapUrl : `https://${seller.shopMapUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                title={seller.shopMapUrl}
                              >
                                {seller.shopMapUrl}
                              </a>
                            ) : (
                              '—'
                            )}
                          </td>
                          <td className="col-shop-photo">
                            {seller.shopPhotoUrl ? (
                              <img src={`${BASE_URL}${seller.shopPhotoUrl.startsWith('/') ? '' : '/'}${seller.shopPhotoUrl}`} alt="" className="shop-photo-thumb" />
                            ) : (
                              <span className="no-photo">—</span>
                            )}
                          </td>
                          <td>{seller.primaryCategoryName || '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </section>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default SellersInAreaPage;
